import { render, staticRenderFns } from "./SpeechMicButton.vue?vue&type=template&id=6c26bba9&scoped=true"
import script from "./SpeechMicButton.vue?vue&type=script&lang=js"
export * from "./SpeechMicButton.vue?vue&type=script&lang=js"
import style0 from "./SpeechMicButton.vue?vue&type=style&index=0&id=6c26bba9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c26bba9",
  null
  
)

export default component.exports